export default {"src":"/_next/static/media/data-robot-logo.9901b490.svg","height":20,"width":161,"blurWidth":0,"blurHeight":0};